import { UserGroup, AppFeatures } from '../types/global';
import DataStore from '../store';
import { toJS } from 'mobx';

export const getUserGroup = () => {
  const userGroup = localStorage.getItem('selectedGroup');
  if (userGroup) {
    return userGroup as UserGroup;
  }
  return null;
};

export const getAppTitle = () => {
  const groupName: string | undefined = DataStore.config?.name;
  if (groupName) {
    return groupName;
  }

  return 'PCP App';
};

export const getGroupConfiguration = () => {
  return DataStore.config?.pages || null;
};

export const existPageInGroup = (feature: string) => {
  const groupConfig: any | null = DataStore.config?.pages;
  if (!groupConfig) {
    return false;
  }

  return groupConfig[feature]?.enabled || false;
};

export const getPageConfiguration = (feature: AppFeatures) => {
  const group: UserGroup | null = getUserGroup();
  if (feature === 'pipelines') {
    console.log(
      group,
      toJS(getGroupConfiguration()?.[feature]?.settings || null)
    );
  }
  if (!group) {
    return null;
  }

  return getGroupConfiguration()?.[feature]?.settings || null;
};

export const isElementHidden = (feature: string, key: string) => {
  const group: UserGroup | null = getUserGroup();
  if (!group) {
    return false;
  }
  return (
    getGroupConfiguration()?.[feature]?.hiddenForUser.includes(key) || false
  );
};

export const getDefaultConfigValue = <T>(
  feature: AppFeatures,
  key: string,
  fallbackValue: T
): T => {
  const group: UserGroup | null = getUserGroup();
  if (!group) {
    return fallbackValue;
  }

  return (getGroupConfiguration()?.[feature]?.defaults?.[key] ??
    fallbackValue) as T;
};

export const downloadButonAvailable = (part: string) => {
  const group: UserGroup | null = getUserGroup();
  if (!group) {
    return false;
  }
  const groupConfig: any = getGroupConfiguration();
  if (!groupConfig) {
    return false;
  }

  return groupConfig?.search?.downloadAvailable || false;
};

export const filterDisabledValues = (values: any[], disabledValues: any[]) => {
  return values.filter((value: any) => !disabledValues.includes(value));
};

export const groupConfigurationShowField = (value: boolean | undefined) => {
  return value ?? true;
};
